export default __webpack_public_path__ + "static/media/ic_alarm_on_24px.fd4ca73d.svg";